import { InjectionToken } from '@angular/core';

export const GOOGLE_TAG_MANAGER_ID = new InjectionToken<string>('GOOGLE_TAG_MANAGER_ID');
